import { type InjectionKey, type App } from 'vue'
import type { MobileAuthApiClient } from '../generated/mobileAuthApi'

const mobileAuthApiClientKey = Symbol() as InjectionKey<MobileAuthApiClient>

// Must call in Vue component. Provides MobileMissionsApiClient via
// `useMobileMissionsApiClient` in all components subtree.
export function provideMobileAuthApiClient(app: App, apiClient: MobileAuthApiClient) {
  app.provide(mobileAuthApiClientKey, apiClient)
}
